import React, { useState } from 'react';
import AdminPanel from './AdminPanel';
import './ProtectedAdminPanel.css';

const ProtectedAdminPanel: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password === 'jcn1234') {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Falsches Passwort!');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return <AdminPanel />;
  }

  return (
    <div className="protected-admin">
      <div className="login-container">
        <div className="login-form">
          <h2>🔐 Admin-Zugang</h2>
          <p>Bitte geben Sie das Admin-Passwort ein:</p>
          
          <form onSubmit={handleLogin}>
            <div className="input-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort eingeben..."
                className={error ? 'error' : ''}
                autoFocus
              />
            </div>
            
            {error && (
              <div className="error-message">
                ❌ {error}
              </div>
            )}
            
            <button type="submit" className="login-button">
              🔓 Anmelden
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProtectedAdminPanel;